import React from "react";
import styled from "styled-components";

import { Loading } from "commons";
import { nucleus } from "commons/src/NucleusTheme";

export function ButtonLoading(props) {
    return <StyledLoading {...props} size={23} colour={nucleus.secondary} />;
}

const StyledLoading = styled(Loading)`
    text-align: center;
    margin: 8px;
`;
